/**
 *   Created by ATopcu in 2019
 */
import scope from "./scope";
import SelectionState from "state/selections/SelectionState";
import { selectDefinitions } from "./selectors";
import {
  selectCommittedAsOfDateEntity,
  selectCommittedGroupTypeValue,
  selectCommittedGroupValues,
  selectModeValue,
  selectSelectedEntityIds,
} from "state/selections/selector";
import { throwError } from "@ls/error-module";
import { exchange } from "@ls/js-fetch";
import SummaryType from "state/selections/Constants/SummaryType";
import Mode from "state/selections/Mode";
import { selectScenarioEntityIds } from "state/scenario/selector";
import { format } from "date-fns";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_DATA = `${scope}/REQUEST_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_DATA`;
export const requestData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const durationToTargetDefinitions = selectDefinitions(
      SelectionState.COMMITTED
    )(state);

    if (durationToTargetDefinitions.length === 0) {
      return;
    }

    const modeValue = selectModeValue(SelectionState.COMMITTED)(state);
    const scenarioEntityIds = selectScenarioEntityIds(state);
    const selectedEntityIds = selectSelectedEntityIds(SelectionState.COMMITTED)(
      state
    );

    dispatch({ type: REQUEST_DATA });
    const durationToTargetDefinition = durationToTargetDefinitions[0];
    const asOfDateEntity = selectCommittedAsOfDateEntity(state);
    const params = {
      date: format(asOfDateEntity, "MM/dd/yyyy"),
      relative: durationToTargetDefinition.summary !== SummaryType.ABSOLUTE,
    };
    if (modeValue === Mode.ACC_GROUPS) {
      params.type = selectCommittedGroupTypeValue(state);
      params.customGroupId = selectCommittedGroupValues(state)?.join(",");
    } else if (modeValue === Mode.SCENARIOS) {
      params.entityIds = scenarioEntityIds?.join(",");
    } else if (modeValue === Mode.ENTITIES) {
      params.entityIds = selectedEntityIds?.join(",");
    }
    try {
      const { data = {} } = await exchange({
        cancelId: "getTargetMajorDurations",
        baseURL: process.env.REACT_APP_BASE_URL_DURATION_TO_TARGET_SERVICE,
        url: "getTargetMajorDurations",
        params,
      });
      dispatch({ type: RECEIVE_DATA, data: data.results || [] });
    } catch (e) {
      dispatch({ type: RECEIVE_DATA, data: [] });
      console.error(e);
      throwError({
        title: "Duration to Target Error",
        message: JSON.stringify(e),
      });
    }
  };
};
